export const APP_MARKET_BASE_NAME = "appmarket";

export const MAX_ALLOWED_API_LIMIT = 1000;

export const SUGGESTED_APPS_LIMIT = 8;
export const MAX_DESC_STRING_LEN = 105;
export const APP_NAME_MAX_LENGTH = 17;

export const APP_REVIEW_MAX_LENGTH = 1023;
export const APP_REVIEW_TITLE_MAX_LENGTH = 127;
export const APP_REVIEW_MIN_LENGTH = 6;
export const APP_FREE_TRIAL_LENGTH = 30;

export const SUGGEST_APP_MAX_TEXT_LENGTH = 200;
export const SUGGEST_APP_MIN_TEXT_LENGTH = 1;

export const APP_COLLECTION_NAME_MAX_LENGTH = 75;
export const APP_COLLECTION_TABNAME_MAX_LENGTH = 25;

export const SearchConfig = {
  MinCharsRequired: 3,
  MaxCharsAllowed: 300,
  Debounce: 500
}

export const FALLBACK_RATINGS_VISIBILITY_THREASHOLD = 10;

export const CLOVER_DEV_ID = 'CLOVERDEV';
export const YELP_APP_ID = 'WEAM8R4NV62K2';
export const WIRELESS_MANAGER_APP = 'JBCS0CPRQW9WM';

export const ENGINE_NAMES = [
  'virtual-terminal',
  'app-market',
  'cash-log',
  'choose',
  'claim',
  'closeout',
  'cs',
  'customers',
  'developers',
  'discounts',
  'employees',
  'enterprise',
  'internal',
  'inventory',
  'oauth',
  'orders',
  'printers',
  'reporting',
  'setup',
  'site',
  'shifts',
  'tabs',
  'tips',
  'transactions',
  'wireless-manager',
];
